var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 7.58357L12.3827 9.61474C12.4266 9.64396 12.4776 9.66073 12.5303 9.66325C12.583 9.66577 12.6354 9.65395 12.6819 9.62905C12.7284 9.60415 12.7673 9.5671 12.7945 9.52184C12.8216 9.47659 12.8359 9.42483 12.8359 9.37207V4.59107C12.836 4.53975 12.8224 4.48933 12.7967 4.44491C12.771 4.40049 12.7341 4.36364 12.6896 4.33808C12.6451 4.31251 12.5946 4.29914 12.5433 4.29932C12.492 4.29949 12.4416 4.3132 12.3973 4.33907L9.33594 6.12524",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 3.5H2.33073C1.6864 3.5 1.16406 4.02233 1.16406 4.66667V9.33333C1.16406 9.97767 1.6864 10.5 2.33073 10.5H8.16406C8.80839 10.5 9.33073 9.97767 9.33073 9.33333V4.66667C9.33073 4.02233 8.80839 3.5 8.16406 3.5Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.e78c01dbe7f124d3eeebac05f6de456e.svg";
export { ForwardRef as ReactComponent };